var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-switch',{attrs:{"label-right":_vm.filter.label},on:{"input":_vm.updateValue},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }